import React from 'react'
import { Downgraded } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import { Grid, Typography } from '@mui/material'
import ColumnChartHorizontal from '~/components/ColumnChartMui/HorizontalChart'
import { calculateBarChartTotal } from '~/utils/format'
import useManagementQualifiersAnimalsState from '~/features/Management/stores/ManagementQualifiersAnimalState'

interface ChartsAnimalsProps {
  readonly expandFilterSearch: boolean
}

export default function ChartsAnimals({
  expandFilterSearch,
}: ChartsAnimalsProps) {
  const { translate } = useLang()
  const { occurrencesAssociatedAnimals } = useManagementQualifiersAnimalsState()

  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Registered animal')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedAnimals()
            .occurrencesAssociatedAnimalsBySpecie.attach(Downgraded)
            .get()}
          title={'AnimalsType:name'}
          subtitle={`Total de animais: ${calculateBarChartTotal(
            occurrencesAssociatedAnimals()
              .occurrencesAssociatedAnimalsBySpecie.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'species'}
          colorBar="primary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedAnimals()
            .occurrencesAssociatedAnimalsByOccurrenceType.attach(Downgraded)
            .get()}
          title={`${translate('AnimalsModel:name')}`}
          subtitle={`Total de animais: ${calculateBarChartTotal(
            occurrencesAssociatedAnimals()
              .occurrencesAssociatedAnimalsByOccurrenceType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedAnimals()
            .occurrencesAssociatedAnimalsByCircunstance.attach(Downgraded)
            .get()}
          title={`${translate('Situation of the animal')}`}
          subtitle={`Total de animais: ${calculateBarChartTotal(
            occurrencesAssociatedAnimals()
              .occurrencesAssociatedAnimalsByCircunstance.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'situations'}
          colorBar="tertiary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedAnimals()
            .occurrencesAssociatedAnimalsByDestination.attach(Downgraded)
            .get()}
          title={`${translate('Final destination of the animal')}`}
          subtitle={`Total de animais: ${calculateBarChartTotal(
            occurrencesAssociatedAnimals()
              .occurrencesAssociatedAnimalsByDestination.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'finals destinations'}
          colorBar="primary"
        />
      </Grid>
    </Grid>
  )
}
